// extracted by mini-css-extract-plugin
export default {"buttonContainer":"e0d254b30714","userList":"aa27120e6db1","accessChangesList":"f2f8043b88f8"};